module.exports = fox._r("images/faq/top5_bg.png", __webpack_public_path__ + "images/faq/top5_bg.png");


//////////////////
// WEBPACK FOOTER
// ./images/faq/top5_bg.png
// module id = 153
// module chunks = 5